import React from 'react';
import { ChevronRight } from 'lucide-react';

export interface LwFunnelStep {
  key: string;
  label: string;
  count: number | string;
  /** value for the `[data-stage]` dot color; defaults to `key`. */
  stage?: string;
  sub?: string | null;
  goal?: boolean;
  active?: boolean;
  onClick?: () => void;
}

export interface LwFunnelKpi {
  value: React.ReactNode;
  label: React.ReactNode;
}

/** Funnel hero: clickable stage steps with big serif counts + an optional KPI block. */
export function LwFunnel({
  steps,
  kpis,
  chevronSize = 18
}: {
  steps: LwFunnelStep[];
  kpis?: LwFunnelKpi[];
  chevronSize?: number;
}) {
  return (
    <div className="funnel">
      <div className="funnel-flow">
        {steps.map((s, i) => (
          <React.Fragment key={s.key}>
            <button
              className={`fstep${s.active ? ' active' : ''}${s.goal ? ' goal' : ''}`}
              onClick={s.onClick}
              type="button"
            >
              <span className="fstep-count">{s.count}</span>
              <span className="fstep-label">
                <span className="fstep-dot" data-stage={s.stage ?? s.key} />
                {s.label}
              </span>
              {s.sub && <span className="fstep-sub">{s.sub}</span>}
            </button>
            {i < steps.length - 1 && (
              <span className="fchev">
                <ChevronRight size={chevronSize} />
              </span>
            )}
          </React.Fragment>
        ))}
      </div>
      {kpis && kpis.length > 0 && (
        <div className="funnel-kpis">
          {kpis.map((k, i) => (
            <div key={i}>
              <div className="fkpi-num">{k.value}</div>
              <div className="fkpi-label">{k.label}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
